import { setListenersFromSelector } from '../functions/listeners';
import { querySelector } from '../functions/querySelectors';
import moving from '../modules/moving';

const NAV_TOGGLER_OPEN_CLASS = 'js-nav-toggler-open';
const NAV_TOGGLER_CLOSE_CLASS = 'js-nav-toggler-close';
const NAV_TOGGLER_INIT_CLASS = 'jnt-init';
const HEADER_CLASS = 'l-header';
const HEADER_NAV_OPEN_CLASS = 'l-header--open-nav';

let getHeader = function() {
  return querySelector(`.${HEADER_CLASS}`);
};

let showNav = function() {
  getHeader().classList.add(HEADER_NAV_OPEN_CLASS);
  moving.disable();
};

let hideNav = function() {
  getHeader().classList.remove(HEADER_NAV_OPEN_CLASS);
  moving.enable();
};

let togglerClick = function(event) {
  event.preventDefault();
  showNav();
};

let closerClick = function(event) {
  event.preventDefault();
  hideNav();
};

let setMobileNav = function() {
  setListenersFromSelector(
    `.${NAV_TOGGLER_OPEN_CLASS}`,
    NAV_TOGGLER_INIT_CLASS,
    togglerClick,
    false
  );

  setListenersFromSelector(
    `.${NAV_TOGGLER_CLOSE_CLASS}`,
    NAV_TOGGLER_INIT_CLASS,
    closerClick
  );
};

export function navBlog() {
  setMobileNav();
}
